import axios from '@/utils/request'
/// ///////////////////////////////////////路径规划//////////////////////////////////////////

// 获取路径规划数据
export async function getRoutes (mapId) {
  return axios.get('/map/path/page', { params: { mapId, pageSize: 999 } }).then(({ data }) => data.records)
}

// 获取路径规划数据
export async function getRouteDetails (id) {
  return axios.get('/map/path', {
    params: {
      id
    }
  }).then(({ data }) => data)
}

/**
 * 添加或更新路径规划
 * @param {*} points
 * @returns
 */
export async function addOrUpdate (model) {
  if (!model.id) {
    return axios.post('/map/path', model)
  } else {
    return axios.put('/map/path', model)
  }
}
/**
 * 添加或更新路径规划
 * @param {*} points
 * @returns
 */
export async function delRoute (id) {
  return axios.delete('/map/path', {
    data: {
      ids: [id]
    }
  })
}

/**
 * 调用高德的路径规划
 * @param {*} points
 * @returns
 */
export async function routePlanning (model) {
  return axios.post('/common-service-platform/lbsmap/direction', model).then(({ data }) => data)
}
